import React from "react";
import Modal from "./Modal";
import { AlertTriangle } from "lucide-react";

export default function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  data,
}) {
  if (!data) return null;

  const handleConfirm = () => {
    onConfirm(data.id);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Konfirmasi Hapus">
      <div className="space-y-4">
        {/* Warning Icon */}
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-rose-50 ring-1 ring-rose-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-rose-600" />
          </div>
        </div>

        {/* Message */}
        <div className="text-center">
          <h3 className="text-lg font-semibold text-slate-900 tracking-tight mb-2">
            Yakin ingin menghapus data ini?
          </h3>
          <p className="text-sm text-slate-500 mb-4">
            Data yang sudah dihapus tidak dapat dikembalikan.
          </p>

          {/* Data Info */}
          {(data.name || data.category || data.balance || data.total) && (
            <div className="bg-slate-50/70 ring-1 ring-slate-200 rounded-xl p-4 text-left space-y-2">
              {data.name && (
                <div>
                  <p className="text-[11px] uppercase tracking-wider font-medium text-slate-500">
                    Nama
                  </p>
                  <p className="text-sm font-semibold text-slate-900">
                    {data.name}
                  </p>
                </div>
              )}
              {data.category && (
                <div>
                  <p className="text-[11px] uppercase tracking-wider font-medium text-slate-500">
                    Kategori
                  </p>
                  <p className="text-sm font-semibold text-slate-900">
                    {data.category}
                  </p>
                </div>
              )}
              {(data.balance || data.total) && (
                <div>
                  <p className="text-[11px] uppercase tracking-wider font-medium text-slate-500">
                    Total Saldo
                  </p>
                  <p className="text-sm font-semibold text-slate-900">
                    {data.balance || data.total}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-2">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-white ring-1 ring-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-medium text-sm">
            Batal
          </button>
          <button
            onClick={handleConfirm}
            className="px-5 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors font-medium text-sm shadow-sm shadow-rose-600/20">
            Hapus
          </button>
        </div>
      </div>
    </Modal>
  );
}
